goog.provide("shadow.js.shim.module$$mui$material$ListItemText");
goog.provide("module$shadow_js_shim_module$$mui$material$ListItemText");
shadow.js.shim.module$$mui$material$ListItemText = shadow.js.nativeProvides["@mui/material/ListItemText"] = shadow$bridge("@mui/material/ListItemText");
module$shadow_js_shim_module$$mui$material$ListItemText.default = shadow.js.shim.module$$mui$material$ListItemText;
